import ChalkySticks from '@chalkysticks/sdk';

/**
 * Whether dialog manager has been initialized
 *
 * @type boolean
 */
let hasInitialized: boolean = false;

/**
 * Reference to the alert prompt component
 *
 * @type any
 */
let alertPromptRef: any = null;

/**
 * Set the alert prompt reference from App.vue.
 *
 * @param any ref
 * @return void
 */
export function setAlertPromptRef(ref: any): void {
	alertPromptRef = ref;
}

/**
 * Initialize dialog event listeners.
 *
 * @return void
 */
export function initialize(): void {
	if (hasInitialized) {
		return;
	}

	ChalkySticks.Core.Event.Bus.on('dialog:alert', Handle_OnDialogAlert);
	ChalkySticks.Core.Event.Bus.on('dialog:confirm', Handle_OnDialogConfirm);
	ChalkySticks.Core.Event.Bus.on('dialog:prompt', Handle_OnDialogPrompt);

	hasInitialized = true;
}

/**
 * Handle alert dialog event.
 *
 * @param any e
 * @return Promise<void>
 */
async function Handle_OnDialogAlert(e: any): Promise<void> {
	if (!alertPromptRef) {
		ChalkySticks.Utility.Log.warn('app', 'Alert prompt ref not set');
		return;
	}

	const message = e.data.message || 'Thank you for using ChalkySticks!';
	const title = e.data.title || 'Alert';

	await alertPromptRef.alert(message, title);
	alertPromptRef.close();
}

/**
 * Handle confirm dialog event.
 *
 * @param any e
 * @return Promise<void>
 */
async function Handle_OnDialogConfirm(e: any): Promise<void> {
	if (!alertPromptRef) {
		ChalkySticks.Utility.Log.warn('app', 'Alert prompt ref not set');
		return;
	}

	const callback = e.data.callback;
	const message = e.data.message || '';
	const title = e.data.title || 'Confirm';

	const result = await alertPromptRef.confirm(message, title);

	if (typeof callback === 'function') {
		callback(result);
	}

	alertPromptRef.close();
}

/**
 * Handle prompt dialog event.
 *
 * @param any e
 * @return Promise<void>
 */
async function Handle_OnDialogPrompt(e: any): Promise<void> {
	if (!alertPromptRef) {
		ChalkySticks.Utility.Log.warn('app', 'Alert prompt ref not set');
		return;
	}

	const callback = e.data.callback;
	const message = e.data.message || '';
	const options = e.data.options || [];
	const title = e.data.title || 'Prompt';

	const value = await alertPromptRef.prompt(message, title, options);

	if (typeof callback === 'function') {
		callback(value);
	}

	alertPromptRef.close();
}
